import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import Utility from '../../util/utilityfunctions';

export default function duplicateDocumentsReducer(state = initialstate.duplicateDocuments, action) {
	switch (action.type) {
		case types.ADD_DUPLICATE_DOCUMENT:
			return [...state, action.meta.document].sort((a, b) =>
				a.documentName.toLowerCase() > b.documentName.toLowerCase() ? 1 : -1
			);

		case types.CLEAR_DUPLICATE_DOCUMENTS:
			return [];

		case types.SELECT_DOCUMENT_OVERWRITE:
			return state.map((doc) => {
				if (doc.documentName === action.meta.documentName) {
					return {...doc, isOverwrite: action.meta.isOverwrite};
				}
				return doc;
			});

		case 'UPCHUNK_CREATE_DOCUMENT_METADATA': {
			if (action.error?.response?.status === 412) {
				let newState = [...state];
				let currentDocument = newState.find(
					(x) => x.id === action.error.response.data.Id || x.documentId === action.error.response.data.Id
				);
				if (currentDocument) {
					currentDocument.isDuplicate = true;
					return newState;
				}

				if (action.parentName) {
					const taskId = Utility.parseGuidFromString(action.parentName);
					return [
						...state,
						{
							id: action.error.response.data.Id,
							documentId: action.error.response.data.Id,
							documentName: action.error.response.data.Name || action.error.response.data.OriginalFileName,
							isDuplicate: true,
							parentName: action.parentName,
							payload: {
								parentName: action.parentName,
								relatedEntityId: action.data?.relatedEntityId,
								taskId: taskId
							}
						}
					];
				}
			}
			return state;
		}

		default:
			return state;
	}
}
